<template>
  <div class="container">
    <div class="mainPart">
      <div class="iconBox"></div>
      <div class="tip">已提交注销申请，若您的账户已无余额或<br />待处理事项，管理员将进行审核通过，通<br />过后不再另行通知，请耐心等待</div>
    </div>
    <div class="optBox">
      <div class="btn alert tapActive" @click="cancelHandler()">取消申请</div>
      <div class="btn normal tapActive" @click.stop="$router.go(-1)">返回</div>
    </div>
  </div>
</template>

<script>
import { LogoutCancel } from '@/api/logoutApplyFor'
import { mapActions } from 'vuex'
// import { LOGOUT_APPLY_FOR_STATUS } from '@/constants/index'
export default {
  name: 'inReview',
  methods: {
    ...mapActions(['loginOut']),
    cancelHandler() {
      this.$dialog
        .alert({
          title: '提示',
          message: '确认取消账号注销申请吗？',
          showCancelButton: true
        })
        .then(() => {
          this.LogoutCancelHandler()
        })
        .catch(() => {
          // on cancel
        })
    },
    async LogoutCancelHandler() {
      try {
        const { Msg } = await LogoutCancel()
        this.$toast(Msg)
        setTimeout(() => {
          this.$router.replace({
            name: 'appUserInfo'
          })
        }, 1500)
      } catch (error) {
        this.$toast(error.ErrMsg)
        if (error.ErrMsg === '您的注销申请已审核通过，无法取消，正在退出登录...') {
          setTimeout(() => {
            this.loginOut().then(() => {
              this.$uni.postMessage({
                data: {
                  logOut: true
                }
              })
            })
          }, 1500)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './css/applyForAccountCancellationStep';
.container {
  .mainPart {
    width: 100%;
    .iconBox {
      width: 100%;
      height: vw(300);
      background: url('~@/assets/image/bg1.png');
      background-size: vw(400) vw(400);
      background-position: center center;
    }

    .tip {
      text-align: center;
      font-size: vw(16);
    }
  }
}
</style>
